/** Unicode characters. */
export const UTF8 = {
  right_triangle: '\u25B8',
  down_triangle: '\u25BE',
  nbsp: '\u00A0',
  down_arrow: '\u2193',
  diamnod: '\u2736',
}